import { EventEmitter, Injectable } from '@angular/core';
import { BcPrivilegesFacade } from '@bayclubs/employee-auth';
import { Observable } from 'rxjs';

@Injectable()
export class CampsSecurityService {
    public isLoaded = false;

    constructor(private privileges: BcPrivilegesFacade) {
    }

    public canUseCamps(): Observable<boolean> {
        return this.privileges.hasPrivilege('Camps.campsCanView', []);
    }

    public canManageCamps(): Observable<boolean> {
        return this.privileges.hasPrivilege('Camps.campsCanManage', []);
    }

    public canViewReports(): Observable<boolean> {
        return this.privileges.hasPrivilege('Camps.canViewReports', []);
    }

    public canSellCamps(): Observable<boolean> {
        return this.privileges.hasPrivilege('Camps.canSellCamps', []);
    }
}

